import React, { useCallback } from 'react';
import { Block, HeadingBlockData } from '../../../config';
import LiveText from '../../LiveText';
import { readSubscripts } from '../../../subscript';
import './heading-block.scss';

interface HeadingBlockProps {
  block: Block;
  onChange: (data: HeadingBlockData) => void;
  onDelete: () => void;
  isEditing: boolean;
  onEnter?: (currentContent: string) => void;
}

const HeadingBlock: React.FC<HeadingBlockProps> = ({ block, onChange, isEditing, onEnter }) => {
  const data = block.data as HeadingBlockData;

  const handleTextChange = useCallback((text: string) => {
    onChange({ ...data, text });
  }, [data, onChange]);

  const handleKeyDown = useCallback((e: React.KeyboardEvent<HTMLElement>) => {
    // Handle Enter key - create new paragraph below
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onEnter?.(readSubscripts(e.currentTarget));
    }
  }, [onEnter]);

  const tag = (data.level === 1 ? 'h1' : data.level === 3 ? 'h3' : 'h2') as 'h1' | 'h2' | 'h3';

  return (
    <div className={`heading-block level-${data.level}`}>
      {/* Committed as typed, like every other text field (see LiveText). */}
      <LiveText
        as={tag}
        className="heading-text"
        value={data.text || ''}
        editable={isEditing}
        restoreKey={`${block.id}:heading`}
        onCommit={handleTextChange}
        onKeyDown={isEditing ? handleKeyDown : undefined}
        data-placeholder="Heading"
      />
    </div>
  );
};

export default HeadingBlock;
